import React, {useEffect} from 'react';
import {Redirect, Route, Switch} from 'react-router';
import {useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';

import {selAdminToken, selBaseStatus, selBaseStatusShow, selUserToken} from '../stores/base/baseSlice';
import {VERIFIED} from '../constants/actions';
import {
    My404Component,
    Login,
    // CounterChart,
    CreateProduct,
    TodayRequest,
    ListProducts,
    CreateProductType,
    Categories,
    Orders,
    Sliders,
    Slider,
    Dashboard,
    CreateProduct2,
    BasicInformation,
    ProductTypes,
    ProductType,
    Category,
    Order,
    Attributes,
    Tags,
    Agencies,
    Agency,
    ReportOrders,
    Attribute,
    Blog,
    Tag,
    Users,
    User,
    Reporting,
    Notices,
    Notice,
    DiscountCodes,
    DiscountCode,
    AdminUsers,
    AdminUser
} from './module'
import Blogs from "./Pages/Blogs/Blogs";
import SlideImages from "./Pages/Sliders/Slide_images";
import Message from "./Pages/Message/Message";




const RestrictedRoute = ({component: Component, ...rest}) => {
    const appStatus = useSelector(selBaseStatus);
    // const { authUser } = useSelector(({ auth }) => auth);
    return (
        <Route
            {...rest}
            render={(props) =>
                appStatus === VERIFIED ? (
                    <Component {...props} />
                ) : (
                    <Redirect
                        to={{
                            pathname: '/signin',
                            state: {from: props.location},
                        }}
                    />
                )
            }
        />
    );
};

const Routes = () => {
    const appStatus = useSelector(selBaseStatus);
    const location = useLocation();
    // const { authUser } = useSelector(({ auth }) => auth);
    if (location.pathname === '' || location.pathname === '/') {
        return <Redirect to={'/dashboard'}/>;
    } else if (appStatus === VERIFIED && location.pathname === '/signin') {
        return <Redirect to={'/dashboard'}/>;
    }

    return (
        <React.Fragment>
            <Switch>
                {/*<Route path="/dashboard" component={Counter}/>*/}
                <Route path="/dashboard" exact component={Dashboard}/>
                <Route path="/signin" component={Login}/>
                {/*<Route path="/dashboard" exact component={CounterChart}/>*/}
                <Route exact path="/products" component={ListProducts}/>
                <Route exact path="/product" component={CreateProduct2}/>
                <Route exact path="/product/:slug" component={CreateProduct2}/>
                {/*<Route exact path="/product" component={BasicInformation}/>*/}
                <Route exact path="/productTypes" component={ProductTypes}/>
                <Route exact path="/productType" component={ProductType}/>
                {/*<Route exact path="/productType/:slug" component={ProductType}/>*/}
                <Route exact path="/categories" component={Categories}/>
                <Route exact path="/category" component={Category}/>
                <Route exact path="/category/:id" component={Category}/>
                {/*<Route exact path="/productTypes" component={CreateProductType}/>*/}
                <Route exact path="/orders" component={Orders}/>
                <Route exact path="/order/:id" component={Order}/>
                <Route exact path="/sliders" component={Sliders}/>
                <Route exact path="/slider" component={Slider}/>
                <Route exact path="/slider/:id" component={Slider}/>
                <Route exact path="/slide-image/:id" component={SlideImages}/>
                <Route exact path="/attributes" component={Attributes}/>
                <Route exact path="/attribute" component={Attribute}/>
                <Route exact path="/attribute/:id" component={Attribute}/>
                <Route exact path="/tags" component={Tags}/>
                <Route exact path="/tag" component={Tag}/>
                <Route exact path="/tag/:id" component={Tag}/>
                <Route exact path="/agencies" component={Agencies}/>
                <Route exact path="/agency/:id" component={Agency}/>
                <Route exact path="/agency" component={Agency}/>
                <Route exact path="/blogs" component={Blogs}/>
                <Route exact path="/blog" component={Blog}/>
                <Route exact path="/blog/:id" component={Blog}/>
                <Route exact path="/reportOrders" component={ReportOrders}/>
                <Route exact path="/users" component={Users} />
                <Route exact path="/user" component={User} />
                <Route exact path="/user/:id" component={User} />
                <Route exact path="/adminUsers" component={AdminUsers} />
                <Route exact path="/adminUser" component={AdminUser} />
                <Route exact path="/adminUser/:id" component={AdminUser} />
                <Route exact path="/message" component={Message} />
                <Route exact path="/reporting" component={Reporting} />
                <Route exact path="/notices" component={Notices} />
                <Route exact path="/notice" component={Notice} />
                <Route exact path="/notice/:id" component={Notice} />
                <Route exact path="/discount-codes" component={DiscountCodes} />
                <Route exact path="/discount-code" component={DiscountCode} />
                <Route exact path="/discount-code/:id" component={DiscountCode} />
                <Route path="/" exact component={TodayRequest}/>

                {/*<Route exact path="/testimonials" component={Testimonials} />*/}
                {/*<Route exact path="/testimonial/:id" component={Testimonial} />*/}
                {/*<Route exact path="/testimonial/" component={Testimonial} />*/}

            </Switch>
        </React.Fragment>
    );
};

const MainLayoutApp = () => {
    const appStatus = useSelector(selBaseStatus);
    const location = useLocation();
    const appStatusShow = useSelector(selBaseStatusShow);
    // const { authUser } = useSelector(({ auth }) => auth);
    if(appStatusShow !== "show"){
        return <></>
    }
    if (location.pathname === '' || location.pathname === '/') {
        return <Redirect to={'/dashboard'} />;
    }
    else if (appStatus === VERIFIED && location.pathname === '/signin') {
        return <Redirect to={'/'} />;
    }
    return (
        <React.Fragment>
            <Switch>
                <Route exact path="/signin" component={Login}/>
                <RestrictedRoute path="/" component={Routes}/>
                <Route component={My404Component}/>
            </Switch>
        </React.Fragment>
    );
};

export default MainLayoutApp;
